import { RadioGroup } from '@/containers/forms/RadioGroup'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { Alert, Flex, Radio, Text, VStack } from '@chakra-ui/react'
import { TextareaFormControl } from 'BrokerTsLib/src/components'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'react-hook-form'

export const PoleasInformationForm = () => {
  const { isDisabled } = useInsuranceParams()
  const methods = useFormContext<InsuranceParamsDto>()
  const { setValue, watch, formState: { errors } } = methods
  const value = watch('generalParams.paramsDataValid')

  return (
    <>
      <Alert status='warning' p={8}>
        <VStack w={'100%'} gap={8}>

          <Flex gap={8} alignSelf='flex-start' alignItems='center'>
            <Text fontSize='xl' fontWeight='semibold'>
              Jsou všechny výše uvedené údaje správné?
            </Text>

            <RadioGroup
              name="generalParams.paramsDataValid"
              value={value === true ? '1' : value === false ? '0' : ''}
              valueTransform={(value) => value?.toString() ?? ''}
              isDisabled={isDisabled}
              stackProps={{ spacing: 8 }}
              onChange={(e) => {
                setValue('generalParams.paramsDataValid', e === '1')
              }}>
              <Radio value='1'><Text fontSize='xl' >Ano</Text></Radio>
              <Radio value='0'><Text fontSize='xl' >Ne</Text></Radio>
            </RadioGroup>
          </Flex>

          {value == false &&
                        <TextareaFormControl
                          isRequired
                          name={'generalParams.paramasDisagreements'}
                          placeholder="Uveďte nesrovnalosti v uvedených údajích a odešlete je, budeme Vás kontaktovat."
                          label="Nesrovnalosti v uvedených údajích"
                          labelProps={{
                            hint: 'Uveďte nesrovnalosti v uvedených údajích a odešlete je, budeme Vás kontaktovat.',
                          }}
                          w={'100%'}
                          isDisabled={isDisabled}
                        />
          }
        </VStack>
      </Alert>
    </>
  )
}